// Combine all admin event keys into a single object
import { AdminBillingEventKeys } from "./billing";
import { AdminCaseworkersEventKeys } from "./caseworkers";
import { AdminCommunicationsEventKeys } from "./communications";
import { AdminDashboardEventKeys } from "./dashboard";
import { AdminNeedsEventKeys } from "./needs";
import { AdminReportsEventKeys } from "./reports";
import { AdminSettingsEventKeys } from "./settings";
import { AdminStoriesEventKeys } from "./stories";
import { AdminTaxReceiptsEventKeys } from "./tax-receipts";
import { AdminUsersEventKeys } from "./users";
import { AdminVolunteersEventKeys } from "./volunteers";

export const AdminEventKeys = {
  ...AdminNeedsEventKeys,
  ...AdminUsersEventKeys,
  ...AdminVolunteersEventKeys,
  ...AdminCaseworkersEventKeys,
  ...AdminReportsEventKeys,
  ...AdminSettingsEventKeys,
  ...AdminDashboardEventKeys,
  ...AdminStoriesEventKeys,
  ...AdminCommunicationsEventKeys,
  ...AdminTaxReceiptsEventKeys,
  ...AdminBillingEventKeys,
} as const;

// Combine all admin event catalogs into a single catalog
import { AdminBillingEventCatalog } from "./billing";
import { AdminCaseworkersEventCatalog } from "./caseworkers";
import { AdminCommunicationsEventCatalog } from "./communications";
import { AdminDashboardEventCatalog } from "./dashboard";
import { AdminNeedsEventCatalog } from "./needs";
import { AdminReportsEventCatalog } from "./reports";
import { AdminSettingsEventCatalog } from "./settings";
import { AdminStoriesEventCatalog } from "./stories";
import { AdminTaxReceiptsEventCatalog } from "./tax-receipts";
import { AdminUsersEventCatalog } from "./users";
import { AdminVolunteersEventCatalog } from "./volunteers";

export const AdminEventCatalog = {
  ...AdminNeedsEventCatalog,
  ...AdminUsersEventCatalog,
  ...AdminVolunteersEventCatalog,
  ...AdminCaseworkersEventCatalog,
  ...AdminReportsEventCatalog,
  ...AdminSettingsEventCatalog,
  ...AdminDashboardEventCatalog,
  ...AdminStoriesEventCatalog,
  ...AdminCommunicationsEventCatalog,
  ...AdminTaxReceiptsEventCatalog,
  ...AdminBillingEventCatalog,
};
